/** Highest number of passengers per one category */
export const passengerCountPerCategoryUpperLimit = 100

/** Lowest number of passengers per one category */
export const passengerCountPerCategoryLowerLimit = 0

/** Minimum number of passengers from any category */
export const minTotalPassengersCount = 1